// extracted by mini-css-extract-plugin
export default {"main":"verify-import_main__G0n2C","title":"verify-import_title__B+mgF"};